import styled from 'styled-components'
import { StyledMobileNavList } from '../Header/HeaderStyles'

export const HomeWrapper = styled.section`
  grid-area: 1/1 / end/end;
  position: relative;
  z-index: 6;
  background: linear-gradient(
      ${({ theme }) => theme.colors.defaultOverlay},
      ${({ theme }) => theme.colors.defaultOverlay}
    ),
    url(${({ theme }) => theme.images.homeBg});
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 500px) {
    background-position: 100% 50%;
  }
  @media (min-width: 750px) {
    display: grid;
    background: ${({ theme }) => theme.colors.primaryColor};
    grid-template-columns: 1fr 1fr;
  }
  .first-half {
    @media (min-width: 750px) {
      grid-area: 1/1/-1/2;
      height: 100vh;
      display: grid;
      grid-template-rows: minmax(max-content, 85vh) minmax(min-content, 15vh);
      align-items: center;
    }
    footer {
      grid-area: 2/1/-1/-1;
    }
    h1 {
      grid-area: 1/1/-1/-1;
    }
  }
`;

export const MainHeading = styled.h1`
  align-self: center;
  font-size: 3.5rem;
  font-weight: 300;
  margin: 5% auto 0;
  border: 3px solid currentColor;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 2rem;
  width: 80vw;
  @media (min-width: 500px) {
    margin: auto auto;
    align-self: center;
  }
  @media (min-width: 750px) {
    font-size: 3rem;
    max-width: 300px;
  }
  span {
    display: block;
    width: 100%;
  }
  span:nth-of-type(2) {
    text-transform: uppercase;
  }
`;
export const SideWrapper = styled.div`
  @media (min-width: 750px) {
    width: 100%;
    height: 100%;
    grid-area: 1/2/-1/-1;
    background: linear-gradient(
        ${({ theme }) => theme.colors.defaultOverlay},
        ${({ theme }) => theme.colors.defaultOverlay}
      ),
      url(${({ theme }) => theme.images.homeBg});
    background-size: cover;
    background-position: 100% 50%;
    background-repeat: no-repeat;
  }
`;
export const FooterLinks = styled(StyledMobileNavList)`
  display: none;
  @media (min-width: 750px) {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    flex-direction: row;
    font-size: 1.2rem;
    li:not(last-child){
        margin: 0 auto;
        :nth-of-type(even){
            border: none;
        }
    }
  }
`;